import { Dialog, DialogContent, Box, Typography, Button, IconButton, Divider } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface InsuranceBenefitModalProps {
    open: boolean
    onClose: () => void
    title: string
    description: string
    price: string
    isSelected: boolean
    buttonCta: string
    onButtonClick: () => void
}

const InsuranceBenefitModal: React.FC<InsuranceBenefitModalProps> = ({
    open,
    onClose,
    title,
    description,
    price,
    isSelected,
    buttonCta,
    onButtonClick
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 2,
                        p: 0
                    }
                }
            }}
        >
            <DialogContent sx={{ p: 0 }}>
                <Box sx={{ position: 'relative', px: 3, pt: 2 }}>
                    {/* Close Button */}
                    <IconButton
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 16,
                            top: 16,
                            bgcolor: 'grey.100',
                            '&:hover': {
                                bgcolor: 'grey.200'
                            }
                        }}
                        size="small"
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>

                    {/* Title */}
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 600,
                            mb: 2,
                            pr: 5, // Make room for close button
                            color: 'text.primary'
                        }}
                    >
                        {title}
                    </Typography>

                    {/* Description */}
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                            lineHeight: 1.5,
                            mb: 3
                        }}
                        dangerouslySetInnerHTML={{
                            __html: description
                        }}
                    />

                    {/* Price and Button in same line */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 3
                        }}
                    >
                        {/* Price Display */}
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                color: 'text.primary'
                            }}
                        >
                            {price}
                        </Typography>

                        {/* Select Button */}
                        <Button
                            variant={isSelected ? 'contained' : 'outlined'}
                            size="small"
                            sx={{
                                minWidth: 96,
                                textTransform: 'none',
                                fontWeight: 500,
                                borderRadius: 1,
                                borderColor: 'primary.main'
                            }}
                            onClick={onButtonClick}
                        >
                            {buttonCta}
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default InsuranceBenefitModal
export type { InsuranceBenefitModalProps }
